import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import { get } from 'lodash-es';

import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';
import EditInfos from './EditInfos';
import { configLegalInfos } from '../config';

const BlockLegalInfos = ({ party, strings, i18n, updatePartyCompany, mode, setViewMode, id }) => {
  const { fields, initialValues } = configLegalInfos({ party, strings });

  const contentViewBlock = (
    <div className="content">
      <ItemField label={strings['party.edit.field.code.label'] || 'Code'} value={party.code} />

      <div className="group">
        <ItemField label={strings['party.edit.field.name.label'] || 'Name'} value={party.name} name="name" optional />
      </div>
    </div>
  );

  const contentEditBlock = (
    <div className="content" key={`legal-informations-${id}`}>
      <EditInfos
        id={party.id}
        initialValues={initialValues}
        fields={fields}
        updateParty={updatePartyCompany}
        setViewMode={setViewMode}
        buttonSubmitLabel={strings['party.edit.block.button.submit.label'] || 'Enregistrer les modifications'}
        locale={get(i18n, 'lang', 'fr')}
      />
    </div>
  );

  return mode === 'view' ? <>{contentViewBlock}</> : <>{contentEditBlock}</>;
};

BlockLegalInfos.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  party: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  i18n: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  updatePartyCompany: PropTypes.func,
  mode: PropTypes.oneOf(['edit', 'view']).isRequired,
  setViewMode: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

BlockLegalInfos.defaultProps = {
  party: {},
  strings: {},
  i18n: fromJS({}),
  // eslint-disable-next-line no-console
  updatePartyCompany: (...params) => console.log('updatePartyPerson', ...params),
};

const config = {
  title: 'party.edit.block.legal-informations.label',
  defaultTitle: 'Legal Informations',
  name: 'legal-informations',
};

export default withToggleView(BlockLegalInfos, config);
